import { transactionsDetailKeys } from "Api/Queries/Transactions/useTransactionsDetail";
import {
  type ErrorResponse,
  putTransactionsPublicIDTip,
  type TransactionDetailDto,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Translations/Resources";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

type Props = {
  onSuccess?: (data: TransactionDetailDto) => void;
  onError?: (error: ErrorResponse) => void;
};

type Parameters = {
  publicID: string;
  tipAmount: number;
};

export const useUpdateTransactionTip = ({ onSuccess, onError }: Props = {}) => {
  const queryClient = useQueryClient();
  const { t } = useResource();

  return useMutation<TransactionDetailDto, ErrorResponse, Parameters>({
    mutationFn: processResponseWithApiProblemDetails(
      ({ publicID, tipAmount }: Parameters) =>
        putTransactionsPublicIDTip({ tipAmount }, publicID),
    ),
    onSuccess: (data, { publicID }) => {
      queryClient.invalidateQueries({
        queryKey: transactionsDetailKeys.byPublicId(publicID),
      });
      onSuccess?.(data);
    },
    onError: (error: ErrorResponse) => {
      toast.error(t(Resources.Hooks.Transaction.TipUpdateError));
      onError?.(error);
    },
  });
};
